
/* eslint-disable camelcase */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en_US from '../lang/en_US'

Vue.use(VueI18n)

const numberFormats = {
    en_US: {
        currency: {
            style: 'currency', currency: 'USD'
        }
    }
}

export default new VueI18n({
    fallbackLocale: 'en_US',
    silentFallbackWarn: process.env.NODE_ENV !== 'development',
    silentTranslationWarn: process.env.NODE_ENV !== 'development',
    numberFormats,
    messages: {
        en_US
    }
})
